import React from 'react';
import { compose } from 'recompose';
import format from 'date-fns/format';
import glamorous from 'glamorous';
import ReactTooltip from 'react-tooltip';
import Airfare from './Airfare';
import { Flex, Div, LightText } from './hocs/withStyles';
import theme from '../theme';

const toF = temp => temp * 9 / 5 + 32;

const DestinationInfo = ({
  name,
  cityName,
  flagSVG,
  countryCode,
  country,
  distance,
  originName,
  iataCode
}) => (
  <Flex css={styles.destiInfoContainer}>
    <Flex>
      <Flex css={styles.destiInfo}>
        <h3>{cityName}</h3>
        <Div css={styles.country}>
          <glamorous.Img
            src={flagSVG}
            width="14px"
            minWidth="14px"
            height="10px"
            borderRadius="2px"
          />
          <LightText> {country}</LightText>
        </Div>
      </Flex>
    </Flex>
  </Flex>
);

const Destination = compose()(props => {
  const { dailyWeather, maxHigh, degreeUnit, countryCode } = props;
  let flagSVG;
  try {
    flagSVG = require(`../svgs/flags/${countryCode}.svg`);
  } catch (err) {}
  return (
    <Flex width="100%" p={[2]} flexWrap="wrap">
      <ReactTooltip />
      <DestinationInfo {...props} flagSVG={flagSVG} />
      <Flex flex="5 0 280px" p={[0, 2, 0, 0]} css={styles.weatherContainer}>
        {dailyWeather.map(f => {
          const w = f.weather[0];
          const weatherIcon = theme.matchWeatherIcon(w.description);
          const ts = f.dt * 1000;
          const day = format(ts, 'ddd D');
          const fullDay = format(ts, 'dddd DD MMMM YYYY');
          let dayHigh = f.temp.max;
          const isHighest = maxHigh === dayHigh;
          if (degreeUnit === 'F') {
            dayHigh = toF(f.temp.max);
          }
          dayHigh = Math.round(dayHigh);
          return (
            <Flex
              key={f.dt}
              direction="column"
              alignItems="center"
              width="25%"
              p={[0]}
              m={[0, 0, 2, 0]}
            >
              <Flex color="blue" data-tip={fullDay}>
                <h5>{day}</h5>
              </Flex>
              <Flex width="67%" justifyContent="center">
                <glamorous.Img
                  src={weatherIcon}
                  alt={w.description}
                  width={w.description.includes('snow') ? '75%' : '100%'}
                  height="100px"
                />
              </Flex>
              <Flex justifyContent="center">
                {isHighest ? (
                  <strong style={{ fontWeight: 900 }}>
                    {dayHigh}°{degreeUnit}
                  </strong>
                ) : (
                  <span>
                    {dayHigh}°{degreeUnit}
                  </span>
                )}
              </Flex>
              <Flex justifyContent="center">
                <LightText>
                  <small>
                    {Math.round(degreeUnit === 'F' ? toF(f.temp.night) : f.temp.night)}°{
                      degreeUnit
                    }
                  </small>
                </LightText>
              </Flex>
            </Flex>
          );
        })}
      </Flex>
      <Flex m={[0, 0, 0, 3]} flex="3 0 150px" css={styles.airfareContainer}>
        <Airfare {...props} />
      </Flex>
    </Flex>
  );
});

export default Destination;

const styles = {
  destiInfoContainer: {
    flexDirection: 'column',
    flex: '1 0 100px',
    height: '90px',
    justifyContent: 'space-between',
    '@media (orientation: portrait)': {
      flexDirection: 'row',
      height: '50px',
      flex: '1 0 100%'
    }
  },
  destiInfo: {
    flexDirection: 'column',
    width: '100%',
    '@media (orientation: portrait)': {
      flexDirection: 'row'
    }
  },
  country: {
    fontSize: '0.8em',
    alignItems: 'center',
    position: 'relative',
    top: '2px',
    '@media (orientation: portrait)': {
      paddingLeft: '2.8em'
    }
  },
  weatherContainer: {
    borderRight: '1px solid #eee',
    '@media (orientation: portrait)': {
      borderRight: 0
    }
  },
  airfareContainer: {
    '@media (orientation: portrait)': {
      marginLeft: '1.3em',
      marginTop: '1.3em'
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Destination.js